import { useTranslation } from 'react-i18next';

import { ErrorMessage, Loading, withValidPermission } from '@Components';
import { useFetchData } from '@CustomHooks';
import { Permission } from '@Models';
import { bopsApi } from '@Network';
import FieldServices from './fieldServices';

const FieldServicesContainer = () => {
  const { t } = useTranslation();

  const { data, isLoading, error } = useFetchData(bopsApi.getFieldServices);

  if (isLoading) return <Loading title={t('FieldService.Loading')} />;

  if (error || !data) {
    return <ErrorMessage internalMessage={`Unable to get field services: ${error}`} />;
  }

  return <FieldServices fieldServices={data} />;
};

// Manage is listed too because it implies view, mirroring the backend's
// view_field_services = ValidatePermission(["view:field_services", "manage:field_services"]).
export default withValidPermission(FieldServicesContainer, [
  Permission.ViewFieldServices,
  Permission.ManageFieldServices,
]);
